<template>
  <!-- 普通参照 -->
  <div class="dictNameBox" style="width: 100%">
    <template v-if="view">
      <span style="white-space: nowrap">
        {{ INT(showName) }}
      </span>
    </template>
    <template v-else>
      <!-- <mrc_ess_input :error-messages="errMsg"
                     v-show="disabled"
                     :label="label"
                     :backgroundColor="backgroundColor"
                     readonly
                     :placeholder="placeholder || label"
                     :value="INT(showName)">
      </mrc_ess_input> -->
      <v-autocomplete
        :value="dictName"
        :readonly="disabled"
        :disabled="disabledTwo"
        :items="dict_arr"
        :no-data-text="noDataText"
        :item-value="dict_value"
        :filter="filterArr"
        :append-icon="disabled ? '' : 'arrow_drop_down'"
        :search-input.sync="search"
        :background-color="backgroundColor ? backgroundColor : disabled ? '#ffffff' : '#f5f5f5'"
        :item-text="dict_label"
        :label="label"
        :multiple="multiple"
        @change="dictNameChange"
        :placeholder="placeholder ? removestar(placeholder) : disabled ? ' ' : removestar(label)"
        :chips="chips"
        :clearable="clearable"
        :filled="filled"
        :error-messages="errMsg"
        :rules="myRules"
      >
        <template v-slot:no-data>
          <mrc_ess_noContent
            height="50"
            type="2"
            svgFontSize="50"
            :no_data_text="$t('label_blank')"
          />
        </template>

        <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            v-if="multiple"
            :input-value="data.selected"
            :close="!disabled"
            @click="data.select"
            @click:close="remove(data.item)"
          >
            <span
              v-if="data.item.dict_value_color"
              :style="{ 'background-color': data.item.dict_value_color }"
              style="width: 20px; height: 20px; display: inline-block; border-radius: 50%"
            >
            </span>
            <v-img
              width="30"
              v-if="data.item.dict_value_img && !data.item.dict_value_color"
              :src="data.item.dict_value_img"
              aspect-ratio="1.4"
              contain
            ></v-img>
            <span v-if="!data.item.dict_value_img && !data.item.dict_value_color">
              {{ INT(data.item[dict_label]) }}
            </span>
          </v-chip>

          <div v-else class="d-flex align-center">
            <div v-if="colorView" class="d-flex align-center">
              <div
                :style="{
                  'background-color': dictName,
                  width: '15px',
                  height: '15px',
                  borderRadius: '50%'
                }"
                class="mr-2"
              ></div>
              <div :style="{ color: INT(data.item[dict_label]) }">
                {{ INT(data.item[dict_label]) }}
              </div>
            </div>
            <!--  v-bind="data.attrs" -->
            <v-chip
              v-else-if="chips"
              :input-value="data.selected"
              :close="!disabled"
              @click="data.select"
              @click:close="remove(data.item)"
            >
              <span
                v-if="data.item.dict_value_color"
                :style="{ 'background-color': data.item.dict_value_color }"
                style="width: 20px; height: 20px; display: inline-block; border-radius: 50%"
              >
              </span>
              <v-img
                width="30"
                v-if="data.item.dict_value_img && !data.item.dict_value_color"
                :src="data.item.dict_value_img"
                aspect-ratio="1.4"
                contain
              ></v-img>
              <span v-if="!data.item.dict_value_img && !data.item.dict_value_color">
                {{ INT(data.item[dict_label]) }}
              </span>
            </v-chip>

            <span v-else>
              <span
                v-if="data.item.dict_value_color"
                :style="{ 'background-color': data.item.dict_value_color }"
                style="width: 20px; height: 20px; display: inline-block; border-radius: 50%"
              >
              </span>
              <v-img
                width="30"
                v-if="data.item.dict_value_img && !data.item.dict_value_color"
                :src="data.item.dict_value_img"
                aspect-ratio="1.4"
                contain
              ></v-img>
              <span
                style="color: rgba(0, 0, 0, 0.87)"
                v-if="!data.item.dict_value_img && !data.item.dict_value_color"
              >
                {{ INT(data.item[dict_label]) }}
              </span>
            </span>
          </div>
        </template>
        <!-- 下拉数据 -->
        <template v-slot:item="data">
          <template v-if="typeof data.item !== 'object'">
            <v-list-item-content v-text="data.item"></v-list-item-content>
          </template>
          <template v-else>
            <v-list-item-content
              class="pa-0"
              style="height: 48px; border-bottom: 1px solid rgb(224, 224, 224)"
              v-if="multiple && data.item.allcheck"
            >
              <div @click.stop="allcheck" style="height: 48px" class="px-4">
                <v-checkbox
                  class="pt-4"
                  :label="$t('label_select_all')"
                  :on-icon="
                    statusCheck == 'indeterminate' ? '$checkboxIndeterminate' : '$checkboxOn'
                  "
                  readonly
                  v-model="statusCheck"
                >
                </v-checkbox>
              </div>
            </v-list-item-content>
            <div v-else style="height: 48px" class="d-flex align-center pl-4">
              <v-checkbox v-if="multiple" class="pt-6" v-model="data.attrs.inputValue">
              </v-checkbox>
              <v-list-item-content v-if="colorView" style="height: 48px">
                <div class="d-flex">
                  <div
                    :style="{
                      'background-color': INT(data.item[dict_label]),
                      width: '15px',
                      height: '15px',
                      borderRadius: '50%'
                    }"
                    class="mr-2"
                    v-if="colorView"
                  ></div>
                  <div :style="{ color: INT(data.item[dict_label]) }">
                    {{ INT(data.item[dict_label]) }}
                  </div>
                </div>
              </v-list-item-content>
              <v-list-item-content v-else style="height: 48px">
                <div>
                  <span
                    v-if="data.item.dict_value_color"
                    :style="{ 'background-color': data.item.dict_value_color }"
                    style="width: 20px; height: 20px; display: inline-block; border-radius: 50%"
                  >
                  </span>
                  <v-img
                    width="30"
                    v-if="data.item.dict_value_img && !data.item.dict_value_color"
                    :src="data.item.dict_value_img"
                    aspect-ratio="1.4"
                    contain
                  ></v-img>
                  <span v-if="!data.item.dict_value_img && !data.item.dict_value_color">
                    {{ INT(data.item[dict_label]) }}
                  </span>
                </div>
              </v-list-item-content>
            </div>
          </template>
        </template>
      </v-autocomplete>
    </template>
  </div>
</template>

<script>
/**
 * info 公用普通参照组件 可传单个dict_name 或者 对象形式 多个参数
 * @params label 标签名
 * @params disabled 是否禁用
 * @params obj 请求的条件 dict_name 等
 * @params noDataText 没有下拉显示的文字
 * @params select_arr 下拉的数据
 * @params multiple 多选
 * @params rules 为空时显示的字，默认为 必填
 * @params clearable 清空
 * @params chips 纸片
 * @params errMsg 手动提示错误消息 rules必须传false
 * @params dict_name 只有一个参照名字的参数时就可能不用传obj直接传名字
 * @params dictName 这个是传的value值
 * @event  getData  select 改变的事件
 * 使用 <mrc_ess_mrc_ess_dictName></mrc_ess_dictName>
 */
import { get_dict_name } from '@/service/api/data_dictionary';
export default {
  components: {},
  props: {
    colorView: {
      //颜色显示
      type: Boolean,
      default: false,
    },
    filled: {},
    backgroundColor: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    dict_value: {
      type: String,
      default: 'dict_value',
    },
    dict_label: {
      type: String,
      default: 'dict_label',
    },
    errMsg: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    chips: {
      type: Boolean,
      default: false,
    },
    dict_name: {
      type: String,
    },
    label: {
      type: String,
    },
    disabled: {
      //只读
      type: Boolean,
    },
    disabledTwo: {
      //禁用
      type: Boolean,
      default: false,
    },
    obj: {
      type: Object,
      default: () => { },
    },
    noDataText: {
      type: String,
    },
    select_arr: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
    },
    rules: {
      type: [String, Boolean],
    },
    dictName: {
      type: [Array, String, Number, null],
    },
    view: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: null,
      dict_arr: [],
      requestData: {},
      skLoading: true,
      showName: '',
      nationalPromptArr: [],
    };
  },
  model: {
    prop: 'dictName',
    event: 'getData',
  },
  async created() { },
  async mounted() {
    this.nationalPromptArr = this.select_arr;
    this.changeLang();
    // this.skLoading = true
    if (this.select_arr.length <= 0) {
      if (typeof this.obj == 'string') {
        const dictName = await get_dict_name({ dict_name: this.obj });
        if (dictName.code == 200) {
          this.dictName_arr = dictName.data;
          this.$emit('getDictData', this.dict_arr);
        }
      } else {
        this.requestData = this.obj ? this.obj : {};
        if (Object.keys(this.requestData).length > 0) {
          const dictName = await get_dict_name({ ...this.requestData });
          if (dictName.code == 200) {
            this.nationalPromptArr = dictName.data;
            this.changeLang();
            this.$emit('getDictData', this.dict_arr);
          }
        }
      }

      if (this.dict_name) {
        const dictName = await get_dict_name({ dict_name: this.dict_name });
        if (dictName.code == 200) {
          this.nationalPromptArr = dictName.data;
          this.changeLang();
          this.$emit('getDictData', this.dict_arr);
        }
      }
    }
    this.setShowName();
    // this.skLoading = false
  },
  methods: {
    allcheck(val) {
      let arr = this.$clone(this.dict_arr);
      // console.log(this.statusCheck, !this.statusCheck);
      if (!this.statusCheck || this.statusCheck == 'indeterminate') {
        let uuids = [];
        arr.splice(0, 1);
        arr.forEach((item) => {
          uuids.push(item[this.dict_value]);
        });
        this.$nextTick(() => {
          this.$emit('getData', uuids);
          this.$emit('getSelectItem', arr);
        });
      } else {
        this.$nextTick(() => {
          this.$emit('getData', []);
          this.$emit('getSelectItem', []);
        });
      }
    },
    removestar(v) {
      return String(v).replace('*', '');
    },
    remove(item) {
      if (this.multiple) {
        const arr = JSON.parse(JSON.stringify(this.dictName)).filter((it) => {
          return it != item[this.dict_value];
        });
        this.$emit('getData', arr);
      } else {
        this.$emit('getData', '');
      }
    },
    filterArr(item, query) {
      if (query) {
        if (!this.INT(item[this.dict_label])) return false;
        const a = this.filterList
          .filter((it) => {
            let key1 = it[this.dict_label];
            let key2 = query;
            if (typeof it[this.dict_label] != 'number') {
              key1 = it[this.dict_label].toLowerCase();
              key2 = query.toLowerCase();
            }
            return String(key1).includes(String(key2));
          })
          .map((its) => its[this.dict_value]);
        return a.includes(item[this.dict_value]);
      }
    },
    formatList(arr) {
      const key = this.dict_label;
      const value = this.dict_value;
      let list = [];
      arr.forEach((item) => {
        if (Array.isArray(item[key])) {
          item[key].forEach((it) => {
            for (let lang in it) {
              if (lang != 'uuid') {
                list.push({
                  [value]: item[value],
                  [key]: it[lang],
                  uuid: it.uuid,
                });
              }
            }
          });
          // console.log(list)
        } else {
          list.push(item);
        }
      });
      // console.log(list)
      return list;
    },
    changeLang() {
      this.dict_arr = this.$clone(this.nationalPromptArr).map((item) => {
        item[this.dict_label] = this.INT(item[this.dict_label]);
        return item;
      });
      if (this.multiple) {
        this.dict_arr = [{ allcheck: 'allcheck' }, ...this.dict_arr];
      }
    },
    dictNameChange(val) {
      this.setShowName();
      this.$emit('getData', val ? val : this.multiple ? [] : '');
    },
    setShowName() {
      if (Object.prototype.toString.call(this.dictName).indexOf('Array') > -1) {
        // let index = []
        // let afterDelArr = []
        let indexArr = this.dictName.reduce((totle, item) => {
          let index = this.dict_arr.findIndex((it) => {
            // if (it[this.dict_value] == item) {
            //   afterDelArr.push(item)
            // }
            return it[this.dict_value] == item;
          });

          totle.push(index);
          return totle;
        }, []);
        // this.$emit('getData', afterDelArr)
        let html = '';
        indexArr.forEach((item, index) => {
          if (item > -1) {
            html +=
              this.dict_arr[item][this.dict_label] +
              (index == indexArr.length - 1 ? '' : '，');
          }
          this.showName = html;
        });
      } else {
        const index = this.dict_arr.findIndex((item) => {
          return item[this.dict_value] == this.dictName;
        });
        if (index != -1) {
          this.showName = this.dict_arr[index][this.dict_label];
        } else {
          this.showName = '';
        }
      }
    },
  },
  computed: {
    statusCheck() {
      let uuidLength = Array.isArray(this.dictName) ? this.dictName.length : 0;
      let length = this.dict_arr.length - 1;
      // console.log(uuidLength, length, this.dictName);
      if (uuidLength == length) return true;
      else if (uuidLength > 0) return 'indeterminate';
      else return false;
    },
    filterList() {
      return this.formatList(this.nationalPromptArr);
    },
    myRules() {
      if (this.rules == false) {
        return [];
      } else {
        return [(v) => !!v || this.rules];
      }
    },
  },
  watch: {
    '$store.state.lang'(val) {
      this.changeLang();
    },
    obj: {
      async handler(val, old) {
        if (JSON.stringify(old) == JSON.stringify(val)) return;
        this.requestData = val;
        if (typeof val == 'string') {
          const dictName = await get_dict_name({ dict_name: val });
          if (dictName.code == 200) {
            this.nationalPromptArr = dictName.data;
            this.changeLang();
            this.$emit('getDictData', this.dict_arr);
          }
        } else {
          // 这里有个return 阻断执行，，报错看看这个
          for (var i in this.requestData) {
            if (i != 'dict_name') {
              if (!this.requestData[i]) return;
            }
          }
          if (!this.requestData.dict_name) return;
          const dictName = await get_dict_name({ ...this.requestData });
          if (dictName.code == 200) {
            this.nationalPromptArr = dictName.data;
            this.changeLang();
            this.skLoading = false;
          }
        }
        if (this.dict_name) {
          this.setShowName();
        }
        this.$forceUpdate()
      },
      deep: true,
    },
    select_arr: {
      handler(val) {
        this.nationalPromptArr = val;
        this.changeLang();
        this.setShowName();
      },
      deep: true,
    },
    dictName: {
      handler(val) {
        if (val == '') this.showName = '';
        this.dict_arr.length > 0 && this.setShowName();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.dictNameBox /deep/ .v-input__append-inner {
  margin-top: 8px;
  margin-right: 8px;
}
.dictNameBox /deep/ .v-input__slot {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.dictNameBox /deep/.v-input .v-label {
  top: 2px !important;
}
/deep/ .v-list-item__content {
  min-height: 40px !important;
  max-height: 56px !important;
}
.v-input--selection-controls {
  margin: 0;
  padding: 0;
}
/deep/ .v-select__slot {
  min-height: 40px;
}
/deep/ .v-select__selections {
  min-height: 40px;
  padding-left: 8px;
}
/deep/ .v-list-item {
  min-height: 40px !important;
  padding: 0;
}
/deep/ .v-list-item__content {
  min-height: 40px !important;
}
.overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
/deep/ .v-input__append-inner {
  margin-top: 8px;
  margin-right: 8px;
}
.v-application--is-ltr .v-text-field .v-input__prepend-inner {
  padding: 0 !important;
}
</style>
